export enum CANDIDATES_GROUPS {
  ALL = 'all',
  BASE = 'base',
  COMMUNICATION = 'communication',
  REQUESTS = 'requests',
  WAIT = 'wait',
  WORK = 'work',
  SEARCH = 'search',
  ARCHIVE = 'archive',
  FAVOURITE = 'favourite',
}
